const formatTitle = (type: string) =>
	type
		.split('-')
		.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');

export default formatTitle;
